import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from "@angular/router"; import { AuthenticationService, UtilityService } from "../providers";
import { Observable, of, throwError } from "rxjs";
import { map, catchError, tap, mergeMap, switchMap } from "rxjs/operators";
import { HttpResponse, HttpErrorResponse } from "@angular/common/http";
import { PageLoaderService } from '../ui-components/page-loader/';

declare var ENV_PORTAL: any;
@Injectable()
export class AdminGuard implements CanActivate {
  private jiraScriptLoaded: boolean = false;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService, private pageloaderService: PageLoaderService) {

  }
  path: ActivatedRouteSnapshot[];
  route: ActivatedRouteSnapshot;

  canActivate(state: ActivatedRouteSnapshot): Observable<boolean>  {

    const ivuser = state.queryParams['iv-user'];
    const stubid = state.queryParams['stubId'];
    const client = state.queryParams['client'];
    const rkey = state.queryParams['rkey'];

    if (ivuser) sessionStorage.setItem('iv-user', ivuser);
    if (stubid) sessionStorage.setItem('stubId', stubid);
    if (client) sessionStorage.setItem('client', client);
    if (rkey) sessionStorage.setItem('rkey', rkey);
    // const attESSec = this.authenticationService.getCookie('attESSec');
    // const attESHr = this.authenticationService.getCookie('attESHr');
    // if (attESSec) sessionStorage.setItem('attESSec', attESSec);
    // if (attESHr) sessionStorage.setItem('attESHr', attESHr);
    //get admin flag for logout
    let adminLogoutFlag = localStorage.getItem('adminLogout') ? JSON.parse(localStorage.getItem('adminLogout')) : null;
    // MFA fixes added for halo.e junction integration
    // let u = (localStorage.getItem('user')) ? localStorage.getItem('user') :
    // (sessionStorage.getItem('user')) ? sessionStorage.getItem('user') :
    //   undefined;
    // if (u == undefined) {
    //   // MFA fixes added for halo.e junction integration
    //   this.pageloaderService.setPageLoaderStatus(true);
    //   AuthenticationService.User$.subscribe(u => {
    //     if (u && u != 'loading') {
    //       this.authenticationService.gloablLogin();
    //     }
    //     // else{
    //     //     this.loadJiraScript();
    //     //     return this.authenticationService.getUserDetails();
    //     // }
    //   });
    // }
    //  else return this.authenticationService.validateUser()
    //    .pipe(mergeMap(result => {
    //     this.loadJiraScript();
    //      return this.authenticationService.getUserDetails()
    //    }),catchError(this.handleError));
    return this.authenticationService.getUserDetails()
       .pipe(mergeMap(result => {
        this.loadJiraScript();
          return of(true); 
       }),catchError(this.handleError));      
}
  handleError(error: HttpErrorResponse): Observable<boolean> {
    let client = sessionStorage.getItem('client');
    if (!client || client.length < 1) {
      localStorage.setItem('loginFail', error.status.toString());
      if (ENV_PORTAL.toUpperCase() != "DMPADMIN"){
        window.location.href = '/businessconsole/home';
      }else{
        this.authenticationService.gloablLogin();
      }
      
    }
    return of(true);
  }

  private loadJiraScript(): void {
    if (!this.jiraScriptLoaded) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src =
        'https://attjira.web.att.com/s/a45b5b119109957ce5602e56c3690b94-T/-vi1pbo/820001/13g6npj/7110d639841f4d969f43b16805968318/_/download/contextbatch/js/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/batch.js?locale=en-US&collectorId=1c9a4f04';
      script.async = true;
      document.body.appendChild(script);
      this.jiraScriptLoaded = true; // Ensure the script is loaded only once
    }
  }
  

}
